import { Layers } from "lucide-react";
import { useClasses } from "@/lib/activeClass";

export default function ClassSwitcher() {
  const { classes, classId, setClassId } = useClasses();
  if (classes.length < 2) return null;
  return (
    <div className="bg-white border-b border-[#E2E8F0] px-4 lg:px-8 py-2 flex items-center gap-3 overflow-x-auto" data-testid="class-switcher">
      <span className="flex items-center gap-1.5 text-xs font-semibold text-[#5C736A] whitespace-nowrap"><Layers className="w-4 h-4 text-[#1F7A63]" /> Classe de travail</span>
      <div className="flex gap-1.5">
        {classes.map((c) => (
          <button key={c.id} type="button" onClick={() => setClassId(c.id)} data-testid={`class-switch-${c.nom}`}
            className={`h-9 px-4 rounded-full text-sm font-semibold border whitespace-nowrap transition-colors ${classId === c.id ? "bg-[#1F7A63] border-[#1F7A63] text-white" : "bg-white border-[#E2E8F0] hover:border-[#1F7A63]"}`}>
            {c.nom}{c.organisation === "multigrade" ? " · multigrade" : ""}
          </button>
        ))}
      </div>
    </div>
  );
}
